<template>
    <div>
        <!-- hides for bigger data -->
        <v-expansion-panels v-if="formattedData && JSON.stringify(formattedData).length > 500" flat class="bg-transparent">
          <v-expansion-panel class="bg-transparent">
            <v-expansion-panel-header class="p-0">Show {{ text }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <pre :style="{whiteSpace: 'break-spaces'}">{{ formattedData }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- show normal formattedData -->
        <pre v-else-if="formattedData" class="text-dark pt-3" :style="{textWrap: 'wrap'}">{{ formattedData }}</pre>

        <!-- no data -->
        <p v-else class="pt-3">No {{ text }} Found</p>
    </div>
</template>

<style scoped type="text/css">
  .v-expansion-panel-header {
    font-size: 14px;
  }
</style>
<script>
export default {
    props: {
        data: { default: null },
        text: { type: String, default: '' }
    },

    computed: {
      formattedData () {

        // if no data or not a string, return as-is (handles objects, arrays, null, etc.)
        if (!this.data || typeof this.data !== 'string') {
          return this.data
        }

        // Check if the string is valid JSON
        try {
          JSON.parse(this.data)
          // If parsing succeeds, it's JSON → return as-is
          return this.data
        } catch (e) {
          // Not JSON → apply formatting
          return this.data.replace(/<br\s*\/?>/gi, '\n')
        }
      }
    }
}
</script>